import AOS from "aos";
import { useEffect } from "react";
import BrandsMarqueSection from "../../common/BrandsMarqueSection";
import Cursor from "../../common/Cursor";
import Footer from "../../common/Footer";
import Header from "../../common/Header";
import Loader from "../../common/Loader";
import Meta from "../../common/Meta";
import ProgressCircle from "../../common/ProgressCircle";
import TestimonialSlider from "../../common/TestimonialSlider";
import LatestProjects3D from "./LatestProjects3D";
import SectionFour from "./SectionFour";
import SectionOne from "./SectionOne";
import SectionSeven from "./SectionSeven";
import SectionThree from "./SectionThree";
import SectionTwo from "./SectionTwo";
const Home = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);
  return (
    <>
      <Meta
        title="Home | Marichi Tech AI"
        description="Marichi Tech AI offers innovative web, mobile, and cloud solutions."
        keywords="Marichi Tech, web development, cloud services"
        image="https://example.com/home-og-image.jpg"
      />

      <Loader />
      <div className="site_contain">
        {/* <!-- ====================================== Cusrsor ===================================== --> */}
        <Cursor />
        {/* <!-- ====================================== Cursor End ===================================== --> */}
        {/* <!-- ====================================== Header Menu ===================================== --> */}
        <Header />
        {/* <!-- ====================================== Header Menu End===================================== --> */}
        {/* <!-- ====================================== Section One Start ===================================== --> */}
        <SectionOne />
        {/* <!-- ====================================== Section One End ===================================== --> */}
        {/* <!-- ====================================== Section Two Start===================================== --> */}
        <SectionTwo />
        {/* <!-- ====================================== Section Two End ===================================== --> */}
        {/* <!-- ====================================== Brands Marquee Section Start ===================================== --> */}
        <BrandsMarqueSection />
        {/* <!-- ====================================== Brands Marquee Section End ===================================== --> */}
        {/* <!-- ====================================== Section Three Start===================================== --> */}
        <SectionThree />
        {/* <!-- ====================================== Section Three End===================================== --> */}
        {/* <!-- ====================================== Section Four Start===================================== --> */}
        <SectionFour />
        {/* <!-- ====================================== Section Four End===================================== --> */}
        {/* <!-- ====================================== Section Five ===================================== --> */}
        <LatestProjects3D />
        {/* <!-- ====================================== Section Five ===================================== --> */}
        {/* <!-- ====================================== Section Six ===================================== --> */}
        <TestimonialSlider />
        {/* <!-- ====================================== Section Six ===================================== --> */}
        {/* <!-- ====================================== Section Seven ===================================== --> */}
        <SectionSeven />
        {/* <!-- ====================================== Section Seven ===================================== --> */}
        {/* <!-- ====================================== Footer ===================================== --> */}
        <Footer />
        {/* <!-- ====================================== Progress Scroll Bottom To Top ===================================== --> */}
        <ProgressCircle />
        {/* <!-- ====================================== Progress Scroll Bottom To Top End ===================================== --> */}
      </div>
    </>
  );
};
export default Home;
